<template>
  <!--
          作者：yel
          时间：2021-3-18
          描述：表单模板
      -->
  <div class="product">
    <!--搜索-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input size="small" v-model="searchForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input size="small" v-model="searchForm.mobile" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="提交时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="searchForm.reg_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 选项卡 -->
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="-1"></el-tab-pane>
        <el-tab-pane label="待审核" name="0"></el-tab-pane>
        <el-tab-pane label="通过" name="1"></el-tab-pane>
        <el-tab-pane label="拒绝" name="2"></el-tab-pane>
      </el-tabs>
    </template>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" border style="width: 100%" v-loading="loading">

          <el-table-column prop="id" label="ID" width="65"></el-table-column>
          <el-table-column prop="user" label="用户" width="120">
            <template  slot-scope="scope">
               <div v-if="scope.row.user">
                  <span>{{scope.row.user.nickName}}</span>
                  <span class="gray9">(用户ID：{{scope.row.user.user_id}})</span>
               </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="120"></el-table-column>
          <el-table-column prop="mobile" label="电话" width="120"></el-table-column>
          <el-table-column prop="level" label="申请级别" width="120">
            <template  slot-scope="scope">
               <div >
                  <el-tag size="small" >{{scope.row.level_name}}</el-tag>
               </div>
            </template>
          </el-table-column>

          <el-table-column prop="region" label="申请区域">
            <template slot-scope="scope">
              <div>
                <el-tag size="small" >{{scope.row.region}}</el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <p class="ww100 text-ellipsis-2" v-if="scope.row.status == 0" style="color: #ffaa00;">待审核</p>
              <p class="ww100 text-ellipsis-2" v-if="scope.row.status == 1" style="color: #009900;">通过</p>
              <p class="ww100 text-ellipsis-2" v-if="scope.row.status == 2" style="color: #990000;">已拒绝</p>
            </template>
          </el-table-column>
          <el-table-column prop="reject_desc" label="拒绝原因"></el-table-column>
          <el-table-column prop="status_time" label="审核时间" width="120"></el-table-column>
          <el-table-column prop="create_time" label="申请时间" width="135"></el-table-column>

          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 0" @click="auditClick(scope.row,'pass')" type="text" size="small" >通过</el-button>
              <el-button v-if="scope.row.status == 0" @click="auditClick(scope.row,'reject')" type="text" size="small" >拒绝</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>


    <!--弹窗引入-->
    <!-- <Op v-if="open_add" :open_add="open_add" :addform="Oneform" @closeDialog="closeDialogFunc($event)"></Op> -->

  </div>
</template>

<script>
  import RegionAgentApplyApi from '@/api/plus/regionagentapply.js';
  // import Op from './dialog/Op.vue';

  export default {
    // components: {
    //   Op,
    // },
    data() {
      return {
        //加载
        loading: true,// true 为加载中   false 加载结束

        // 选项卡控制
        activeName: '-1',

        //搜索控制
        searchForm: {
          name: '',  //姓名
          mobile: ''  ,//电话
          user_id:'',
          reg_date:[]
        },

        //表格数据
        tableData: [],/*列表数据*/
        totalDataNumber: 0,/*总条数*/
        pageSize: 20,/*一页多少条*/
        curPage: 1,/*当前是第几页*/


        /*是否打开添加弹窗*/
        open_add: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },

      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
       // 选项卡 start
       handleClick(tab, event) {
         /*切换选项卡 */
         let self = this;
         self.curPage = 1; //变为第一页
         self.loading = true;//加载中
         self.activeName = tab.name;
         self.getData(); //获取数据
       },
       // 选项卡 end


       /*搜索查询*/
       onSubmit() {
         let self = this;
         self.loading = true;//加载中
         self.getData();//获取数据
       },

      //列表数据 start

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val; //选择的页数
        self.loading = true; //加载中
        self.getData();//获取数据
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;  //调到第一页
        this.pageSize = val; //每页多少条
        this.getData(); //获取数据
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params = self.searchForm; //搜索
        Params.status = self.activeName; //选项卡
        Params.page = self.curPage; //当前页数
        Params.list_rows = self.pageSize;//每页多少条

        //请求接口
        RegionAgentApplyApi.getList(Params, true).then(res => {

          self.loading = false;//加载结束
          self.tableData = res.data.list.data; //把数据给列表
          self.totalDataNumber = res.data.list.total;//一共多少条

        }).catch(error => {
          self.loading = false; //加载结束
        });
      },

      //列表数据 end

      //操作 start
      auditClick(row , type){
        let self = this;
        if(type === 'pass'){
          self.loading = true;
          self.$confirm('确定通过审核吗?', '提示', {
            type: 'warning'
          }).then(() => {
            //请求接口
            RegionAgentApplyApi.audit({
              id: row.id,
              type:'pass'
            }).then(data => {
              self.$message({
                message: '审核成功',
                type: 'success'
              });
              self.getData();
            }).catch(()=>{
              self.loading = false;
            });
          }).catch(()=>{
            self.loading = false;
          });
        }else{
            self.loading = true;
            self.$prompt('请输入拒绝原因?', '提示', {
              confirmButtonText:'确定',
              cancelButtonText:'取消',
              inputValue: '不符合要求申请',
              inputErrorMessage: '请输入拒绝原因',
              inputValidator: (value) => {       // 点击按钮时，对文本框里面的值进行验证
                  if(!value) {
                      return '输入不能为空';
                  }
              }
            }).then((value) => {
              if(value.action == 'confirm'){
                  //请求接口
                  RegionAgentApplyApi.audit({
                    id: row.id,
                    type:'reject',
                    reject_desc:value.value
                  }).then(data => {
                    self.$message({
                      message: '审核成功',
                      type: 'success'
                    });
                    self.getData();
                  }).catch(()=>{
              self.loading = false;
            });
              }
              self.loading = false;
            }).catch(()=>{
              self.loading = false;
            });
        }

      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/regionagent/regionagentapply/index.vue